import React from "react";
import { Header } from "../components/Header";
import { Balance } from "../components/Balance";
import { IncomeExpenses } from "../components/IncomeExpenses";
import { TransactionList } from "../components/TransactionList";
import { useQuery } from "@apollo/client";
import { FETCH_TRANSACTIONS_QUERY } from "../graphql";

function Home() {
  const { loading, error, data } = useQuery(FETCH_TRANSACTIONS_QUERY);
  if (loading) return "Loading...";
  if (error) return `Error! ${error.message}`;

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const allMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const startOfMonth = new Date(`${currentYear}, ${currentMonth + 1}, 1`);

  const transactions = data.getTransactions;
  const filteredTransactions = transactions.filter(
    (t) => new Date(t.createdAt) > startOfMonth
  );

  const transactionSort = [...filteredTransactions];

  return (
    <>
      <Header name="Expense Tracker" />

      <div className="container">
        <h1>{allMonths[currentMonth]}</h1>
        <Balance transactions={transactionSort} time="Month"/>
        <IncomeExpenses transactions={transactionSort} />
        <TransactionList transactions={transactionSort} />
      </div>
    </>
  );
}

export default Home;
